import * as React from 'react'
import { TaskSizeSelectFieldConnected } from './TaskSizeSelectFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_USER_A_ID } from 'mockState'

export const TaskSizeSelectFieldExamples = () => {
  return (
    <div className="TaskSizeSelectFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSizeSelectFieldConnected taskId={MOCK_USER_A_ID} />
      </Provider>
    </div>
  )
}
